module.exports = {
  "zones": {
    "America/Metlakatla": ["z", {
      "wallclock": 1547949600000,
      "format": "AK%sT",
      "abbrev": "AKST",
      "offset": -32400000,
      "posix": 1547978400000,
      "save": 0,
      "rules": "US"
    }, {
      "wallclock": 1541296800000,
      "format": "PST",
      "abbrev": "PST",
      "offset": -28800000,
      "posix": 1541325600000,
      "save": 0
    }, {
      "wallclock": 1446343200000,
      "format": "AK%sT",
      "abbrev": "AKST",
      "offset": -32400000,
      "posix": 1446372000000,
      "save": 0,
      "rules": "US"
    }, {
      "wallclock": 436327200000,
      "format": "PST",
      "abbrev": "PST",
      "offset": -28800000,
      "posix": 436352400000,
      "save": 0
    }, {
      "wallclock": -31536000000,
      "format": "P%sT",
      "abbrev": "PST",
      "offset": -28800000,
      "posix": -31507200000,
      "save": 0,
      "rules": "US"
    }, {
      "wallclock": -757382400000,
      "format": "PST",
      "abbrev": "PST",
      "offset": -28800000,
      "posix": -757353600000,
      "save": 0
    }, {
      "wallclock": -883612800000,
      "format": "P%sT",
      "abbrev": "PST",
      "offset": -28800000,
      "posix": -883584000000,
      "save": 0,
      "rules": "US"
    }, {
      "wallclock": -2188987200000,
      "format": "PST",
      "abbrev": "PST",
      "offset": -28800000,
      "posix": -2188955622000,
      "save": 0
    }, {
      "wallclock": -3225168905000,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": -31578000,
      "posix": -3225223727000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 54822000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "US": [{
      "from": 2007,
      "to": 1.7976931348623157e+308,
      "month": 2,
      "day": [0, 8],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 2007,
      "to": 1.7976931348623157e+308,
      "month": 10,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1967,
      "to": 2006,
      "month": 9,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1987,
      "to": 2006,
      "month": 3,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1976,
      "to": 1986,
      "month": 3,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1975,
      "to": 1975,
      "month": 1,
      "day": [7, 23],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1974,
      "to": 1974,
      "month": 0,
      "day": [7, 6],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1967,
      "to": 1973,
      "month": 3,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1945,
      "to": 1945,
      "month": 7,
      "day": [7, 14],
      "time": 1380,
      "clock": "posix",
      "save": 60,
      "letter": "P",
      "saved": 3600000
    }, {
      "from": 1945,
      "to": 1945,
      "month": 8,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1942,
      "to": 1942,
      "month": 1,
      "day": [7, 9],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "W",
      "saved": 0
    }, {
      "from": 1918,
      "to": 1919,
      "month": 2,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1918,
      "to": 1919,
      "month": 9,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }]
  }
};